import { createRootRoute, Outlet } from "@tanstack/react-router";
import { Suspense } from "react";

export const Route = createRootRoute({
  component: () => (
    <Suspense fallback={<div className="min-h-screen flex items-center justify-center text-muted-foreground">Učitavanje...</div>}>
      <Outlet />
    </Suspense>
  ),
});
